export default __webpack_public_path__ + "static/media/InstallWindowsAgent2.370998e2.md";